<template>
  <div style="width: 100%; height: 100%">
    <div class="searchBox">
      <div class="sort">
        <div
          class="sort_item"
          :class="sortID == 1 ? 'is_active_sort' : ''"
          @click="changeSort(1)"
        >
          政策文件
        </div>
        <div
          class="sort_item"
          :class="sortID == 2 ? 'is_active_sort' : ''"
          @click="changeSort(2)"
        >
          政策产品
        </div>
        <div
          class="sort_item"
          :class="sortID == 3 ? 'is_active_sort' : ''"
          @click="changeSort(3)"
        >
          政策解读
        </div>
        <div
          class="sort_item"
          :class="sortID == 4 ? 'is_active_sort' : ''"
          @click="changeSort(4)"
        >
          政策集锦
        </div>
        <div
          class="sort_item"
          :class="sortID == 5 ? 'is_active_sort' : ''"
          @click="changeSort(5)"
        >
          免申即享
        </div>
        <div
          class="sort_item"
          :class="sortID == 6 ? 'is_active_sort' : ''"
          @click="changeSort(6)"
        >
          活动中心
        </div>
      </div>
      <div class="search">
        <div style="width: 360px">
          <el-input v-model="searchText" placeholder="请输入内容"></el-input>
        </div>
        <div class="searchBtn" @click="handleSearch">搜索</div>
      </div>
    </div>
    <div class="shaixuan" v-if="sortID == 2">
      <!-- 条件筛选 -->
      <div class="CationBox">
        <div class="row">
          <div class="name">项目类别：</div>
          <div class="content">
            <div
              v-for="(item, index) in productType"
              :key="index"
              @click="changeProductSort(index)"
              :class="['item', activeProductType == index ? 'actvCss' : '']"
            >
              {{ item.fullName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="articleList">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#409eff' }"
        v-if="sortID == 1"
        @row-click="handleRowClick"
      >
        <el-table-column prop="title" label="政策名称"> </el-table-column>
        <el-table-column prop="dept" label="发文单位" width="250"> </el-table-column>
        <el-table-column prop="area" label="地区" width="100"> </el-table-column>
        <el-table-column prop="time" label="发布日期" width="150"> </el-table-column>
        <el-table-column prop="view_num" label="阅读次数" width="100"> </el-table-column>
      </el-table>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#409eff' }"
        v-if="sortID == 2"
        @row-click="handleRowClick"
      >
        <el-table-column prop="title" label="政策名称"> </el-table-column>
        <el-table-column prop="dept" label="发文单位" width="200"> </el-table-column>
        <el-table-column prop="area" label="地区" width="80"> </el-table-column>
        <el-table-column prop="time" label="持续时间" width="200"> </el-table-column>
        <el-table-column prop="partition" label="项目类别" width="150"> </el-table-column>
      </el-table>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#409eff' }"
        v-if="sortID == 3"
        @row-click="handleRowClick"
      >
        <el-table-column prop="title" label="政策名称"> </el-table-column>
        <el-table-column label="政策图片" width="150">
          <template slot-scope="scope">
            <div style="padding: 10px">
              <img :src="scope.row.image" alt="" style="width: 100%" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="发文单位" width="200"> </el-table-column>
        <el-table-column prop="time" label="持续时间" width="400"> </el-table-column>
      </el-table>
      <div class="collection" v-if="sortID == 4">
        <div
          class="collection_item"
          v-for="(item, index) in tableData"
          :key="index"
          @click="openCollection(item)"
        >
          <img :src="item.image" alt="" />
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#409eff' }"
        v-if="sortID == 5"
        @row-click="handleShare"
      >
        <el-table-column prop="title" label="政策名称"> </el-table-column>
        <el-table-column prop="source" label="发文单位" width="250"> </el-table-column>
        <el-table-column prop="cate_name" label="支持方式" width="100"> </el-table-column>
        <el-table-column prop="apply_time" label="发布日期" width="150">
        </el-table-column>
        <el-table-column prop="status_str" label="状态" width="100"> </el-table-column>
      </el-table>
      <div class="activity" v-if="sortID == 6">
        <div
          class="activity_item"
          v-for="item in tableData"
          :key="item.id"
          @click="handleActivity(item)"
        >
          <img :src="item.image" alt="" style="width: 300px" />
          <div class="activity_info">
            <div class="title">{{ item.title }}</div>
            <div class="detail">发布时间：{{ item.create_time }}</div>
            <div class="time">活动时间：{{ item.time_str }}</div>
            <div class="address">活动地址：{{ item.address }}</div>
            <div class="status">{{ item.status_str }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="paging">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        :current-page="page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getPolicyList,
  getProductList,
  getUnscrambleList,
  getCollectionList,
  getShareList,
  getActivityList,
  getAllPartition,
} from "@/api/index";
export default {
  data() {
    return {
      searchText: "",
      productType: [{ fullName: "全部" }],
      activeProductType: 0,
      sortID: 1,
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      timer: null,
    };
  },
  mounted() {
    if (this.$route.query.status) {
      this.sortID = this.$route.query.status;
      this.page = 1;
      if (this.sortID == 1) {
        this.getPolicy();
      } else if (this.sortID == 2) {
        this.getProduct();
      } else if (this.sortID == 3) {
        this.getUnscramble();
      } else if (this.sortID == 4) {
        this.getCollection();
      } else if (this.sortID == 5) {
        this.getShare();
      } else if (this.sortID == 6) {
        this.getActivity();
      }
    } else {
      if (this.$route.query.isSearch) {
        console.log(this.$route.query);
        this.searchText = this.$route.query.search;
        this.getPolicy(this.searchText);
      } else {
        this.getPolicy();
      }
    }
    this.getSort();
  },
  methods: {
    getSort() {
      getAllPartition().then((res) => {
        console.log(res.data);
        this.productType = [...this.productType, ...res.data];
      });
    },
    changeSort(key) {
      this.sortID = key;
      this.searchText = "";
      this.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (key == 1) {
          this.getPolicy();
        } else if (key == 2) {
          this.getProduct();
        } else if (key == 3) {
          this.getUnscramble();
        } else if (key == 4) {
          this.getCollection();
        } else if (key == 5) {
          this.getShare();
        } else if (key == 6) {
          this.getActivity();
        }
      });
    },
    getPolicy(search = "") {
      getPolicyList({
        PageIndex: this.page,
        SearchKey: search,
        PageSize: 10,
        Plate: "",
        Area: "RegisterArea_HZDQ_Hunan_ZhuZhouShi",
        Dept: "",
        Isup: "true",
      }).then((res) => {
        this.pageSize = 10;
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.tableData.forEach((item) => {
          item.time = item.updateDateTime.split(" ")[0].split("-").join(".");
          item.view_num = item.view_num + "次";
          if (item.title.indexOf("】") == -1) {
            item.title = "【" + item.area + "】" + item.title;
          }
        });
      });
    },
    getProduct(search = "") {
      getProductList({
        PageIndex: this.page,
        SearchKey: search,
        PageSize: 10,
        Area: "RegisterArea_HZDQ_Hunan_ZhuZhouShi",
        Dept: "",
        Industries: "",
        Attributes:
          this.activeProductType == 0
            ? ""
            : this.productType[this.activeProductType].fullName,
        Isup: "true",
      }).then((res) => {
        this.pageSize = 10;
        this.total = res.data.total;
        this.tableData = res.data.rows;
      });
    },
    getUnscramble(search = "") {
      getUnscrambleList({
        page: this.page,
        keywords: search,
        PageSize: 10,
      }).then((res) => {
        this.pageSize = res.data.data.per_page;
        this.total = res.data.data.total;
        this.tableData = res.data.data.data;
        this.tableData.forEach((item) => {
          item.time = item.starttime + "~" + item.endtime;
        });
      });
    },
    getCollection(search = "") {
      getCollectionList({
        page: this.page,
        keywords: search,
        PageSize: 10,
      }).then((res) => {
        this.pageSize = res.data.data.per_page;
        this.total = res.data.data.total;
        this.tableData = res.data.data.data;
      });
    },
    getShare(search = "") {
      getShareList({
        keywords: search,
        page: this.page,
        source: "list",
      }).then((res) => {
        this.pageSize = res.data.data.per_page;
        this.total = res.data.data.total;
        this.tableData = res.data.data.data;
      });
    },
    getActivity(search = "") {
      getActivityList({
        keywords: search,
        page: this.page,
        source: "list",
      }).then((res) => {
        this.pageSize = res.data.data.per_page;
        this.total = res.data.data.total;
        this.tableData = res.data.data.data;
      });
    },
    handleCurrentChange(currentPage) {
      this.page = currentPage;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.sortID == 1) {
          this.getPolicy(this.searchText);
        } else if (this.sortID == 2) {
          this.getProduct(this.searchText);
        } else if (this.sortID == 3) {
          this.getUnscramble(this.searchText);
        } else if (this.sortID == 4) {
          this.getCollection(this.searchText);
        } else if (this.sortID == 5) {
          this.getShare(this.searchText);
        } else if (this.sortID == 6) {
          this.getActivity(this.searchText);
        }
      });
    },
    changeProductSort(index) {
      this.activeProductType = index;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getProduct(this.searchText);
      }, 200);
    },
    openCollection(opt) {
      if (opt.file) {
        window.open(opt.file);
      } else {
        window.open(opt.linkurl);
      }
    },
    handleRowClick(row) {
      this.$router.push({
        path: "/detail",
        query: { id: row.id, status: this.sortID },
      });
    },
    handleShare(row) {
      this.$router.push({
        path: "/detail",
        query: { id: row.id, status: this.sortID },
      });
    },
    handleActivity(row) {
      this.$router.push({
        path: "/detail",
        query: { id: row.id, status: this.sortID },
      });
    },
    handleSearch() {
      this.page = 1;
      if (this.sortID == 1) {
        this.getPolicy(this.searchText);
      } else if (this.sortID == 2) {
        this.getProduct(this.searchText);
      } else if (this.sortID == 3) {
        this.getUnscramble(this.searchText);
      } else if (this.sortID == 4) {
        this.getCollection(this.searchText);
      } else if (this.sortID == 5) {
        this.getShare(this.searchText);
      } else if (this.sortID == 6) {
        this.getActivity(this.searchText);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.searchBox {
  width: 1200px;
  height: 40px;
  margin: 20px auto 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  .sort {
    display: flex;
    padding: 0 20px;
    flex: 1;
    justify-content: space-around;
    .sort_item {
      flex: 1;
      height: 40px;
      line-height: 37px;
      border-bottom: 3px solid transparent;
      text-align: center;
      cursor: pointer;
    }
    .is_active_sort {
      font-weight: 600;
      border-bottom: 3px solid #409eff;
    }
  }
  .search {
    display: flex;
    .searchBtn {
      width: 88px;
      margin-left: 10px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 40px;
      background: #409eff;
      color: #fff;
      cursor: pointer;
    }
  }
}

.shaixuan {
  width: 1200px;
  margin: 20px auto 0;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .row {
    width: 100%;
    // height: 40px;
    display: flex;
    border-bottom: 1px solid #f6f6f6;
    // padding: 10px;
    align-items: flex-start;

    .more {
      line-height: 30px;
      margin: 2px auto;
      width: 60px;
      font-weight: 500;
      color: #409eff;
      cursor: pointer;
      height: 55px;
      line-height: 55px;
    }

    .name {
      width: 110px;
      // height: 30px;
      line-height: 30px;
      color: #000;
      padding: 10px 20px;
      box-sizing: border-box;
      text-align: left;
    }

    .item {
      display: inline-block;
      border-radius: 3px;
      padding: 0 5px;
      margin: 2px 10px 11px 0;
      line-height: 30px;
      cursor: pointer;
      // user-select: none;
      color: #000;

      div {
        padding: 0 5px;
        margin: 2px 10px 11px 0;
        line-height: 30px;
        cursor: pointer;
      }
    }
  }

  .row > div {
    flex-shrink: 0;
  }

  .row .content {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #f6f6f6;
    padding: 10px;
    text-align: left;
    box-sizing: border-box;
  }

  .row .content .actvCss {
    background: #409eff;
    color: #fff;
  }

  .ContentBox {
    width: 100%;
    // height: 450px;
    overflow: auto;
    padding: 10px;
  }

  .DataListBox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  ::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .DataListBox .item {
    padding: 2px 4px;
    flex-shrink: 0;
    width: 19%;
    height: 60px;
    color: #666;
    border-radius: 3px;
    border: 1px solid #ccc;
    margin-right: 1.25%;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .DataListBox .item div {
    font-size: 12px;
  }

  .DataListBox .item:nth-child(5n) {
    /* 需要一行显示几个商品,nth-child(5n)里的数字就设置成几n */
    margin-right: 0px;
  }

  .nullCss {
    margin: 60px auto;
    font-size: 14px;
    text-align: center;
    color: #999;
  }
}

.dateShaixuan {
  width: 1200px;
  margin: 30px auto 20px;
  border-radius: 5px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.articleList {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  box-sizing: border-box;

  ::v-deep .el-table__header-wrapper {
    thead {
      border-radius: 5px;
      .el-table__cell {
        border-right: none;
      }
      .el-table_1_column_1 {
        border-radius: 8px 0 0 8px;
      }
      .el-table_1_column_5 {
        border-radius: 0 8px 8px 0;
      }

      th {
        div {
          font-weight: 700;
          color: #fff;
        }
      }
    }
  }
  .collection {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .collection_item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
      overflow: hidden;
      cursor: pointer;
      img {
        width: 180px;
        height: 240px;
      }
      .title {
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        margin-top: 5px;
      }
    }
  }
  .activity {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 20px;
    .activity_item {
      width: 50%;
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      cursor: pointer;
      img {
        border-radius: 15px;
        width: 280px;
        height: 210px;
      }
      .activity_info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 20px;
        .title {
          font-size: 20px;
        }
      }
      .status {
        position: absolute;
        top: 0;
        right: 20px;
        background: #409eff;
        color: #fff;
        padding: 5px 10px;
        border-radius: 10px;
      }
    }
  }
}
.paging {
  width: 1200px;
  height: 92px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-table .cell {
  white-space: nowrap;
}
/deep/.el-table__row {
  cursor: pointer;
}
</style>
